import { MuiThemeProvider, Typography } from '@material-ui/core';
import { customizerTheme } from 'assets/theme';
import { WithStyles } from 'decorators/withStyles';
import { IThemeCustomizerModel } from 'interfaces/theme';
import * as React from 'react';
import { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import themeCustomizerService from 'services/themeCustomizer';
import { CDN_URL } from 'settings';

import ImagePicker from './ImagePicker';
import VideoPicker from './VideoPicker';

interface IProps {
  classes?: any;
}

interface IState {
  model: IThemeCustomizerModel;
}

@WithStyles(() => ({
  imageTitle: {
    fontSize: 16,
    marginTop: 4
  }
}))
export default class SideBanner extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      model: null
    };
  }

  componentDidMount() {
    themeCustomizerService
      .getData()
      .pipe(rxjsOperators.logError(), rxjsOperators.bindComponent(this))
      .subscribe(model => {
        this.setState({ model });
      });
  }

  onChangeImage = (image: string) => {
    themeCustomizerService.setData({ bannerRight: image });

    this.setState(oldState => {
      return { ...oldState, model: { ...oldState.model, desktopImage: image } };
    });
  };

  onChangeVideo = (video: string) => {
    themeCustomizerService.setData({ bannerYoutube: video });
  };

  showImage = (image: string) => {
    if (!image) {
      return '';
    }
    return image.startsWith('/') ? `${CDN_URL}${image}` : `${image}`;
  };

  render() {
    const { model } = this.state;
    const { classes } = this.props;

    const recomendations = {
      width: 350,
      height: 1080
    };

    if (!model) {
      return null;
    }

    return (
      <MuiThemeProvider theme={customizerTheme}>
        <div>
          <VideoPicker video={model.bannerYoutube} onChangeVideo={this.onChangeVideo} />

          <Typography variant="subtitle1" className={classes.imageTitle} gutterBottom>
            Imagem
          </Typography>

          <ImagePicker
            recomendations={recomendations}
            onChangeImage={this.onChangeImage}
            image={this.showImage(model.bannerRight)}
            previewDimensions={{ width: '86px', height: '280px' }}
          />
        </div>
      </MuiThemeProvider>
    );
  }
}
